const WorkInProgress = () => {
    return(
        <div>
            Work in progress
        </div>
    )
} 

export default WorkInProgress